<template>
	<div class="comp">
		<div class="grid settings comp-inner">
			<div class="grid header">
					<div class="grid sectiontitle">Prego usa un altro dispositivo</div>
<!-- 					<div class="grid settings">
				<transition name="slide-fade">
					<button @click="save()" v-if="changes" class="btn green" v-loading="hotelloading"><unicon name="save" fill="#fff" /> salva modifiche</button>
				</transition>
				<button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
					</div> -->
				</div>

		</div>
	</div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
import helper from '../Mixins/helper'
export default {
	name: 'Inprogress',
	mixins: [helper],
	props: {
		// hotel: Object
	},
	data () {
	return {
		changes: false
	}
	},
	methods: {
	show (section) {
		console.log(section)
		this.$emit('open', section)
	},
	save () {
		console.log('save')
		// this.$store.dispatch('hotels/updateHotel', this.hotel)
	}
	},
	filters: {

	},
	watch: {

	},
	computed: {

	},
	beforeMount () {

	},
	beforeDestroy () {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
